import {
  Box,
  Typography,
  Paper,
  Container,
  Grid,
  Divider,
} from "@mui/material";
import PublicLayout from "../../layouts/PublicLayout";

export default function CancellationRefund() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: "#f4f6f8", pt: 10, pb: 10 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
                Refund Policy
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Transparent cancellation guidelines for ABNScripts Technologies Pvt. Ltd. services and TPOS hardware.
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={8}>
              <Paper sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Subscription Cancellations</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  Software subscriptions can be cancelled at any time. We offer a **15-day money-back guarantee** for new users. If you are unsatisfied, a full refund will be processed within 10 business days. After the 15-day window, cancellations apply to the next billing cycle.
                </Typography>
                
                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Hardware & Peripherals</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  Hardware (Printers, Scanners, Terminals) can only be returned if found defective upon delivery. Reports must be made within **48 hours** of receipt. Standard manufacturer warranty applies thereafter.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>How to Initiate a Refund</Typography>
                <Typography variant="body1" color="text.secondary">
                  Please email your request to <strong>help@truemenu.in</strong> with your Merchant ID and Invoice copy. All approved refunds are credited back to the original source of payment (Bank/UPI) within **7-10 working days**.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </PublicLayout>
  );
}